const FALLBACK_API_URL = 'https://backend.etojesim.com'

function normalizeEnvValue(value: unknown): string | undefined {
  if (typeof value === 'string') {
    const trimmed = value.trim()
    return trimmed.length > 0 ? trimmed : undefined
  }
  return undefined
}

const rawApiUrl = normalizeEnvValue(import.meta.env.VITE_API_BASE_URL)
const rawWsUrl = normalizeEnvValue(import.meta.env.VITE_WS_BASE_URL)

const apiBaseUrl = rawApiUrl ?? FALLBACK_API_URL
const wsBaseUrl = rawWsUrl ?? apiBaseUrl.replace(/^http/, 'ws') + (rawWsUrl ? '' : '/ws')

export const env = {
  apiBaseUrl,
  wsBaseUrl,
}

export type EnvConfig = typeof env
